import * as mutation_types from '../mutation-types'
import * as action_types from '../action-types'

// initial state
const state = {
    refresh_surveys: false
}

const actions = {
    [action_types.SURVEY_REFRESH] (context, {refresh_surveys}) {
        context.commit(mutation_types.SURVEY_REFRESH_SET, {refresh_surveys: refresh_surveys});
    }
}

// mutations
const mutations = {
    [mutation_types.SURVEY_REFRESH_SET] (state, {refresh_surveys}) {
        state.refresh_surveys = refresh_surveys;
    },
}

export default {
    state,
    actions,
    mutations
}
